<script>
// This tells ESLint that there's a global var named "FB", which comes from the Facebook SDK
/*global FB*/

import axios from "axios";
import EventBus from '../Common/EventBus.js';

export default {
  name: "AuthMixin",
  props: [
    'defaultAuthPage'
  ],
  data() {
    return {
      authPage: null,

      externalLogInError: null,

      // Sign up form
      signUpEmail: null,
      signUpPassword: null,
      signUpConfirm: null,
      signUpError: null,

      // Log in form
      logInEmail: null,
      logInPassword: null,
      logInError: null,
      logInUsesTFA: false,
      logInVerificationCode: null,

      // Reset password request form
      requestPasswordResetEmail: null,
      requestPasswordResetDone: false,
      requestPasswordResetError: null,

      // Reset password form
      resetPasswordEmail: null,
      resetPasswordToken: null,
      resetPasswordPassword: null,
      resetPasswordConfirm: null,
      resetPasswordError: null,

      // Change password form
      changePasswordError: null,
      changePasswordOldPassword: null,
      changePasswordNewPassword: null,
      changePasswordConfirm: null,

      // Enable TFA form
      verifyPhoneNumberError: null,
      verifyPhoneNumberPhoneNumber: null,

      verifyVerificationCodeError: null,
      verifyVerificationCodeVerificationCode: null,

      // External providers
      // googleSignInParams: {
      //   client_id: '66835382455-403e538rnmmpmcp5tocmndleh30g4i5d.apps.googleusercontent.com'
      // },
      // fbSignInParams: {
      //   scope: 'email,user_likes',
      //   return_scopes: true
      // }
    }
  },
  computed: {
    authUser: function () {
      return this.$root.$data.authenticatedUser.username;
    },
    isAuthenticated: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.id;
    }
  },
  methods: {
    getAuthToken: function () {
      return localStorage.getItem('jwt');
    },
    getAuthenticatedUserId: function () {
      this.refreshAuthenticationData();

      return this.$root.$data.authenticatedUser.id;
    },
    refreshAuthenticationData: function () {
      if (!this.$root.$data.authenticatedUser.id && localStorage.getItem('jwt') != null) {
        let roles;
        try { roles = JSON.parse(localStorage.getItem('roles')); } catch (_) { roles = null; }
        if (!localStorage.getItem('id') || !localStorage.getItem('username') || !Array.isArray(roles)) {
          this.logOut();
          return;
        }
        // Use the stored credentials
        axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');

        // On the initial page request/load, $root.$data doesn't yet exist -- not sure what to do about that
        // https://forum.vuejs.org/t/accessing-root-instance-data-methods-on-beforeeach-guards/6148/11
        this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
        this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
        this.$root.$data.authenticatedUser.roles = roles;
        this.$root.$data.authenticated = true;

        this.$emit('authenticated', this.$root.$data.authenticatedUser);
        EventBus.$emit('authenticated', this.$root.$data.authenticatedUser)
      }
    },
    // onGoogleSignInSuccess (googleUser) {
    //   // `googleUser` is the GoogleUser object that represents the just-signed-in user.
    //   // See https://developers.google.com/identity/sign-in/web/reference#users
    //   const profile = googleUser.getBasicProfile();

    //   // The ID token you need to pass to your backend:
    //   var id_token = googleUser.getAuthResponse().id_token;

    //   axios.post('/api/account/loginExternalCredential',
    //   {
    //     "provider": "Google",
    //     "externalId": profile.getId(),
    //     "email": profile.getEmail()
    //   })
    //   .then(response => {
    //     this.processAuthResponse(response);
    //   })
    //   .catch(error => {
    //     this.externalLogInError = this.createErrorMessage(error);
    //     console.log(error);
    //   });      
    // },
    // onGoogleSignInError (error) {
    //   this.externalLogInError = "Unable to sign in to Google: " + error;
    //   console.log('Google Sign In Error', error);
    // },
    // onFacebookSignInSuccess (response) {
    //   FB.api('/me?fields=name,email', user => {
    //     console.log('ID: ' + user.id);
    //     console.log('Name: ' + user.name);
    //     console.log('Email: ' + user.email);
    //     console.log(user);

    //     axios.post('/api/account/loginExternalCredential',
    //     {
    //       "provider": "Facebook",
    //       "externalId": user.id,
    //       "email": user.email
    //     })
    //     .then(response => {
    //       this.processAuthResponse(response);
    //     })
    //     .catch(error => {
    //       this.externalLogInError = this.createErrorMessage(error);
    //       console.log(error);
    //     });        
    //   });
    // },
    // onFacebookSignInError (error) {
    //   this.externalLogInError = "Unable to sign in to Facebook: " + error;
    //   console.log('Facebook Sign In Error', error);
    // },
    onSignUp: function (evt) {
      axios.post('/api/account/register',
      {
        "email": this.signUpEmail,
        "password": this.signUpPassword
      })
      .then(response => {
        this.processAuthResponse(response);
      })
      .catch(error => {
        this.signUpError = this.createErrorMessage(error);
      });
    },
    onLogIn: function (evt) {
      this.logInError = null;
      const generation = this.$root.$data.authGeneration || 0;
      return axios.post('/api/account/login',
      {
        "email": this.logInEmail,
        "password": this.logInPassword,
        "verificationCode": this.logInVerificationCode
      })
      .then(response => {
        if ((this.$root.$data.authGeneration || 0) !== generation) return;
        this.processAuthResponse(response);
      })
      .catch(error => {
        this.logInError = this.createErrorMessage(error);
      });
    },
    onRequestPasswordReset: function (evt) {
      axios.post('/api/account/requestPasswordReset',
      {
        "email": this.requestPasswordResetEmail
      })
      .then(response => {
        //this.processAuthResponse(response);
        this.requestPasswordResetDone = true;
      })
      .catch(error => {
        this.requestPasswordResetError = this.createErrorMessage(error);
      });
    },
    onResetPassword: function (evt) {
      axios.post('/api/account/resetPassword',
      {
        "email": this.resetPasswordEmail,
        "token": this.resetPasswordToken,
        "password": this.resetPasswordPassword
      })
      .then(response => {
        this.processAuthResponse(response);
      })
      .catch(error => {
        this.resetPasswordError = this.createErrorMessage(error);
      });
    },
    onChangePassword: function (evt) {
      axios.post('/api/account/changePassword',
      {
        "oldPassword": this.changePasswordOldPassword,
        "newPassword": this.changePasswordNewPassword
      })
      .then(response => {
        this.processAuthResponse(response);
        this.$parent.$parent.showToast('Your password was changed successfully.', {
          title: 'Password Changed',
          variant: 'success',
          autoHideDelay: 5000
        });
        this.$router.push('/');
      })
      .catch(error => {
        this.changePasswordError = this.createErrorMessage(error);
      });
    },
    onVerifyPhoneNumber: function () {
      axios.post('/api/account/verifyPhoneNumber',
      {
        "phoneNumber": this.verifyPhoneNumberPhoneNumber,
      })
      .then(response => {
        this.$router.push('/verifyVerificationCode');
      })
      .catch(error => {
        this.verifyPhoneNumberError = this.createErrorMessage(error);
      });
    },
    onVerifyVerificationCode: function () {
      axios.post('/api/account/verifyVerificationCode',
      {
        "verificationCode": this.verifyVerificationCodeVerificationCode,
      })
      .then(response => {
        this.$parent.$parent.showToast('Two-factor authentication was successfully enabled on your account.', {
          title: 'Two Factor Authentication Enabled',
          variant: 'success',
          autoHideDelay: 5000
        });

        this.$router.push('/');
      })
      .catch(error => {
        this.verifyVerificationCodeError = this.createErrorMessage(error);
      });
    },
    processAuthResponse: function (response) {
      if (!response || response.status !== 200 || !response.data)
        throw new Error("The server returned an incomplete login response. Please try again.");
      if (response.status == 200) {

        if (response.data.requiresVerificationCode) {
          this.logInUsesTFA = true;
          return;
        }

        if (typeof response.data.jwtToken !== 'string' || !response.data.jwtToken.trim() ||
            typeof response.data.userName !== 'string' || !response.data.userName.trim() ||
            !response.data.id || !Array.isArray(response.data.roles))
          throw new Error('The server returned an incomplete login response. Please try again.');

        this.$root.$data.authenticated = true;
        this.logInUsesTFA = false;
        this.logInVerificationCode = null;
        axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.jwtToken;
        this.$root.$data.authenticatedUser.username = response.data.userName;
        this.$root.$data.authenticatedUser.id = response.data.id;
        this.$root.$data.authenticatedUser.roles = response.data.roles;

        localStorage.setItem('jwt', response.data.jwtToken);
        localStorage.setItem('username', response.data.userName);
        localStorage.setItem('id', response.data.id);
        localStorage.setItem('roles', JSON.stringify(response.data.roles));

        this.$emit('authenticated', this.$root.$data.authenticatedUser);
        EventBus.$emit('authenticated', this.$root.$data.authenticatedUser)
      }
    },
    createErrorMessage: function (error) {
      if (error && error.response && [400, 401].includes(error.response.status) && this.authPage === 'login')
        return 'Unable to log in. Check your email, password and verification code.';
      if (error && !error.response)
        return error.message === 'Network Error' ? 'Unable to reach the server. Check your connection and try again.' :
          (error.message === 'The server returned an incomplete login response. Please try again.' ? error.message : 'Unable to reach the server. Please try again.');
      if (!error || !error.response || !error.response.data || !error.response.data.Details)
        return 'An unexpected error occurred. Please try again.';

      let parts = [];
      parts.push(error.response.data.Details);

      if (error.response.data.SubErrors)
        parts.push(...error.response.data.SubErrors);

      return parts.join('<br />');
    },
    logOut: function () {
      this.$root.$data.authGeneration = (this.$root.$data.authGeneration || 0) + 1;
      delete axios.defaults.headers.common['Authorization'];
      this.$root.$data.authenticated = false;
      this.logInEmail = null;
      this.logInPassword = null;
      this.logInError = null;
      this.logInUsesTFA = false;
      this.logInVerificationCode = null;
      this.$root.$data.authenticatedUser.username = null;
      this.$root.$data.authenticatedUser.id = null;
      this.$root.$data.authenticatedUser.roles = [];

      localStorage.removeItem('jwt');
      localStorage.removeItem('username');
      localStorage.removeItem('id');
      localStorage.removeItem('roles');

      this.$emit('authenticated', null);
      EventBus.$emit('authenticated', null);
    }
  },
  mounted () {
    if (this.defaultAuthPage)
      this.authPage = this.defaultAuthPage;
    else
      this.authPage = 'create';
  }
};
</script>
